import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/events', params),
    getById: (id) => Api.get(`/cent/event/${id}`, null),
    listByUser: (userId, params) => Api.get(`/cent/events/user/${userId}`, params),
    save: (entity) => Api.post('/cent/event', entity),
    update: (id, entity) => Api.put(`/cent/event/${id}`, entity),
    delete: (id) => Api.delete(`/cent/event/${id}`),
    deletePeriodicInstance: (id) => Api.delete(`/cent/periodic/event/${id}`),
    deletePeriodicWithFollowingInstances: (id) => Api.delete(`/cent/periodic/event/${id}/next`),
    deletePeriodicAllInstances: (id) => Api.delete(`/cent/periodic/event/${id}/all`),
    search: (searchText, params) => Api.get('/cent/events/search', {q: searchText, sort: 'timeStart', ...params}),
    getStatusOptions: () => Api.get('/cent/event/statuses'),
    getTypeOptions: () => Api.get('/cent/event/types'),
    getAttendees: (id, options) => Api.get(`/cent/event/${id}/attendees`, options),
    getMyAttendance: (id) => Api.get(`/cent/event/${id}/attendance`),
    addMyAttendance: (id) => Api.post(`/cent/event/${id}/attendance`),
    removeMyAttendance: (id) => Api.delete(`/cent/event/${id}/attendance`),
    addAttendee: (eventId, entity) => Api.post(`/cent/event/${eventId}/attendee`, entity),
    removeAttendee: (eventId, attendeeId) => Api.delete(`/cent/event/${eventId}/attendee/${attendeeId}`),
    bookUsers: (id, userIds) => Api.post(`/cent/event/${id}/book`, {users: userIds}),
    getAttendanceDetails: (id, attendeeId) => Api.get(`/cent/event/${id}/attendee/${attendeeId}`),
    saveAsset: (id, asset) => Api.post(`/cent/event/${id}/asset`, asset),
    listAssets: (eventId) => Api.get(`/cent/event/${eventId}/assets`),
    addAsset: (eventId, assetId) => Api.post(`/cent/event/${eventId}/asset`, {assetId}),
    removeAsset: (eventId, assetId) => Api.delete(`/cent/event/${eventId}/asset/${assetId}`),
    getReminders: (id) => Api.get(`/cent/event/${id}/reminders`),
    getReminder: (eventId, reminderId) => Api.get(`/cent/event/${eventId}/reminder/${reminderId}`),
    saveReminder: (id, reminder) => Api.post(`/cent/event/${id}/reminder`, reminder),
    removeReminder: (eventId, reminderId) => Api.delete(`/cent/event/${eventId}/reminder/${reminderId}`),
    sendEmail: (eventId, subject, message, userList) => Api.post(`/cent/event/${eventId}/email`, {subject, message, userList}),
    changeAttendanceStatus: (attendeeId, eventId, status) => Api.put(`/cent/event/${eventId}/attendee/${attendeeId}/attendanceStatus`, {status}),
    getTrainersEvents: (data) => Api.get('/cent/trainers/events', data),
    getTemplates: () => Api.get('/cent/events/templates'),
    listNotifications: (eventId) => Api.get(`/cent/event/${eventId}/notifications`),
};